import React, { useEffect, useMemo, useRef, useState } from 'react';
import checkVideoType from '../../utilites/checkVideoType';
import { FC } from 'react';
import useCommonProps from '../../hooks/useCommonProps';
import { useProfile } from '@brg/auth';
import urlApi from '../../actions/urlApi';
import { RetryButton, VideoError, VideoErrorCentered, VideoWrap } from '../desktopApp/longread/postblocks/videoblock';
import { useGetVideoData } from './actions/useGetVideoData';
import { useGetVideoType } from './actions/useGetVideoType';
import { useGetVideoRatio } from './actions/useGetVideoRatio';
import { OverlayBoundary } from '../desktopApp/longread/editor/EditorOverlay/styles';
import AspectRatio from '../AspectRatio';
import LazyLoad from 'react-lazyload';
import KinescopePlayer from '@kinescope/react-kinescope-player';
import { getKinescopeVideoId } from '../../utilites/getKinescopeVideoId';
import ReactPlayer from 'react-player';
import { useGetVideoProps } from './actions/useGetVideoProps';
import useLocalization from '../../hooks/useLocalization';
var LazyLoadVideo = function (_a) {
    var children = _a.children;
    return React.createElement(LazyLoad, { offset: 500, once: true, placeholder: React.createElement("div", { style: { height: '600px', background: 'rgba(0,0,0,0.1)' } }, "Loading...") }, children);
};
export var VideoPlayer = function (_a) {
    var _b;
    var link = _a.link, post = _a.post;
    var playerRef = useRef(null);
    var t = useLocalization().t;
    var _c = useState(600), videoHeight = _c[0], setVideoHeight = _c[1];
    var _d = useState(800), videoWidth = _d[0], setVideoWidth = _d[1];
    var _e = useState(false), error = _e[0], setError = _e[1];
    var _f = useCommonProps(), viewType = _f.viewType, colorStyle = _f.colorStyle;
    var _g = useGetVideoProps(link), videoData = _g.videoData, videoType = _g.videoType, ratio = _g.ratio, isVideo = _g.isVideo, shouldDisplayErrors = _g.shouldDisplayErrors;
    if (error) {
        console.log('Video error', shouldDisplayErrors);
    }
    if (videoType === 'nodata') {
        return React.createElement(VideoWrap, { width: videoWidth, height: videoHeight, viewType: viewType }, (post === null || post === void 0 ? void 0 : post.text) === "VIDEO_CONTENT_MASK" ? (React.createElement("div", { style: {
                width: '100%',
                height: '500px',
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "75", height: "74", viewBox: "0 0 75 74", fill: "none" },
                React.createElement("g", { "clip-path": "url(#clip0_9267_582013)" },
                    React.createElement("path", { d: "M16.2405 1.6336C9.569 -2.19328 4.16016 0.941742 4.16016 8.63027V65.3682C4.16016 73.0644 9.569 76.1954 16.2405 72.3721L65.8323 43.9316C72.5061 40.1033 72.5061 33.901 65.8323 30.0737L16.2405 1.6336Z", fill: "#C64839" })),
                React.createElement("defs", null,
                    React.createElement("clipPath", { id: "clip0_9267_582013" },
                        React.createElement("rect", { width: "74", height: "74", fill: "white", transform: "translate(0.5)" })))))) : (React.createElement(VideoError, { colorStyle: colorStyle }, t('editor.courses.errorLink'))));
    }
    if (['vk', 'v', 'rt'].includes(videoType)) {
        var s = ((link === null || link === void 0 ? void 0 : link.match(/src="(.*?)"/)) &&
            (link === null || link === void 0 ? void 0 : link.match(/src="(.*?)"/)[1])) ||
            null;
        s = (_b = (s || '')) === null || _b === void 0 ? void 0 : _b.replace('autoplay=1', 'autoplay=0');
        var h = ((link === null || link === void 0 ? void 0 : link.match(/height="\s*(\d+)"/)) &&
            (link === null || link === void 0 ? void 0 : link.match(/height="\s*(\d+)"/)[1])) ||
            null;
        var w = ((link === null || link === void 0 ? void 0 : link.match(/width="\s*(\d+)"/)) &&
            (link === null || link === void 0 ? void 0 : link.match(/width="\s*(\d+)"/)[1])) ||
            null;
        var jsApiParam = videoType === 'rt' ? '' : '&js_api=1';
        if (s && h && w) {
            return (React.createElement(LazyLoadVideo, null,
                React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                    React.createElement(AspectRatio, { ratio: ratio },
                        React.createElement("iframe", { ref: playerRef, width: w, height: h, scrolling: 'no', frameBorder: 'no', allow: 'autoplay', src: s ? s + jsApiParam : null })))));
        }
    }
    if (error && !shouldDisplayErrors) {
        return null;
    }
    if (error && shouldDisplayErrors) {
        return (React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
            React.createElement(AspectRatio, { ratio: 3 },
                React.createElement(VideoErrorCentered, { colorStyle: colorStyle },
                    "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0432\u0438\u0434\u0435\u043E \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
                    React.createElement(RetryButton, { onClick: function () { return setError(false); } }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430")))));
    }
    if (videoType === 'ksc') {
        return (React.createElement(LazyLoadVideo, null,
            React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                React.createElement(AspectRatio, { ratio: ratio },
                    React.createElement(KinescopePlayer, { ref: playerRef, videoId: getKinescopeVideoId(link || ''), autoPlay: false })))));
    }
    if (isVideo) {
        return (React.createElement(LazyLoadVideo, null,
            React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                React.createElement(AspectRatio, { ratio: ratio },
                    React.createElement(ReactPlayer, { id: 'test', ref: playerRef, url: link, 
                        // playing={isAutoPlaying}
                        width: '100%', height: '100%', controls: true, onError: function (e) {
                            if (e !== '150' &&
                                !(e.name === 'TypeError' && videoType === 'v'))
                                setError(true);
                        } })))));
    }
    return null;
};
//# sourceMappingURL=VideoPlayer.js.mapimport React, { useEffect, useMemo, useRef, useState } from 'react';
import checkVideoType from '../../utilites/checkVideoType';
import { FC } from 'react';
import useCommonProps from '../../hooks/useCommonProps';
import { useProfile } from '@brg/auth';
import urlApi from '../../actions/urlApi';
import { RetryButton, VideoError, VideoErrorCentered, VideoWrap } from '../desktopApp/longread/postblocks/videoblock';
import { useGetVideoData } from './actions/useGetVideoData';
import { useGetVideoType } from './actions/useGetVideoType';
import { useGetVideoRatio } from './actions/useGetVideoRatio';
import { OverlayBoundary } from '../desktopApp/longread/editor/EditorOverlay/styles';
import AspectRatio from '../AspectRatio';
import LazyLoad from 'react-lazyload';
import KinescopePlayer from '@kinescope/react-kinescope-player';
import { getKinescopeVideoId } from '../../utilites/getKinescopeVideoId';
import ReactPlayer from 'react-player';
import { useGetVideoProps } from './actions/useGetVideoProps';
import useLocalization from '../../hooks/useLocalization';
var LazyLoadVideo = function (_a) {
    var children = _a.children;
    return React.createElement(LazyLoad, { offset: 500, once: true, placeholder: React.createElement("div", { style: { height: '600px', background: 'rgba(0,0,0,0.1)' } }, "Loading...") }, children);
};
export var VideoPlayer = function (_a) {
    var _b;
    var link = _a.link, post = _a.post;
    var playerRef = useRef(null);
    var t = useLocalization().t;
    var _c = useState(600), videoHeight = _c[0], setVideoHeight = _c[1];
    var _d = useState(800), videoWidth = _d[0], setVideoWidth = _d[1];
    var _e = useState(false), error = _e[0], setError = _e[1];
    var _f = useCommonProps(), viewType = _f.viewType, colorStyle = _f.colorStyle;
    var _g = useGetVideoProps(link), videoData = _g.videoData, videoType = _g.videoType, ratio = _g.ratio, isVideo = _g.isVideo, shouldDisplayErrors = _g.shouldDisplayErrors;
    if (error) {
        console.log('Video error', shouldDisplayErrors);
    }
    if (videoType === 'nodata') {
        return React.createElement(VideoWrap, { width: videoWidth, height: videoHeight, viewType: viewType }, (post === null || post === void 0 ? void 0 : post.text) === "VIDEO_CONTENT_MASK" ? (React.createElement("div", { style: {
                width: '100%',
                height: '500px',
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "75", height: "74", viewBox: "0 0 75 74", fill: "none" },
                React.createElement("g", { "clip-path": "url(#clip0_9267_582013)" },
                    React.createElement("path", { d: "M16.2405 1.6336C9.569 -2.19328 4.16016 0.941742 4.16016 8.63027V65.3682C4.16016 73.0644 9.569 76.1954 16.2405 72.3721L65.8323 43.9316C72.5061 40.1033 72.5061 33.901 65.8323 30.0737L16.2405 1.6336Z", fill: "#C64839" })),
                React.createElement("defs", null,
                    React.createElement("clipPath", { id: "clip0_9267_582013" },
                        React.createElement("rect", { width: "74", height: "74", fill: "white", transform: "translate(0.5)" })))))) : (React.createElement(VideoError, { colorStyle: colorStyle }, t('editor.courses.errorLink'))));
    }
    if (['vk', 'v', 'rt'].includes(videoType)) {
        var s = ((link === null || link === void 0 ? void 0 : link.match(/src="(.*?)"/)) &&
            (link === null || link === void 0 ? void 0 : link.match(/src="(.*?)"/)[1])) ||
            null;
        s = (_b = (s || '')) === null || _b === void 0 ? void 0 : _b.replace('autoplay=1', 'autoplay=0');
        var h = ((link === null || link === void 0 ? void 0 : link.match(/height="\s*(\d+)"/)) &&
            (link === null || link === void 0 ? void 0 : link.match(/height="\s*(\d+)"/)[1])) ||
            null;
        var w = ((link === null || link === void 0 ? void 0 : link.match(/width="\s*(\d+)"/)) &&
            (link === null || link === void 0 ? void 0 : link.match(/width="\s*(\d+)"/)[1])) ||
            null;
        var jsApiParam = videoType === 'rt' ? '' : '&js_api=1';
        if (s && h && w) {
            return (React.createElement(LazyLoadVideo, null,
                React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                    React.createElement(AspectRatio, { ratio: ratio },
                        React.createElement("iframe", { ref: playerRef, width: w, height: h, scrolling: 'no', frameBorder: 'no', allow: 'autoplay', src: s ? s + jsApiParam : null })))));
        }
    }
    if (error && !shouldDisplayErrors) {
        return null;
    }
    if (error && shouldDisplayErrors) {
        return (React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
            React.createElement(AspectRatio, { ratio: 3 },
                React.createElement(VideoErrorCentered, { colorStyle: colorStyle },
                    "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0432\u0438\u0434\u0435\u043E \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
                    React.createElement(RetryButton, { onClick: function () { return setError(false); } }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0441\u043D\u043E\u0432\u0430")))));
    }
    if (videoType === 'ksc') {
        return (React.createElement(LazyLoadVideo, null,
            React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                React.createElement(AspectRatio, { ratio: ratio },
                    React.createElement(KinescopePlayer, { ref: playerRef, videoId: getKinescopeVideoId(link || ''), autoPlay: false })))));
    }
    if (isVideo) {
        return (React.createElement(LazyLoadVideo, null,
            React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                React.createElement(AspectRatio, { ratio: ratio },
                    React.createElement(ReactPlayer, { id: 'test', ref: playerRef, url: link, 
                        // playing={isAutoPlaying}
                        width: '100%', height: '100%', controls: true, onError: function (e) {
                            if (e !== '150' &&
                                !(e.name === 'TypeError' && videoType === 'v'))
                                setError(true);
                        } })))));
    }
    return null;
};
//# sourceMappingURL=VideoPlayer.js.map